import { render, staticRenderFns } from "./EhrSimTime.vue?vue&type=template&id=0ac74404&scoped=true&lang=pug"
import script from "./EhrSimTime.vue?vue&type=script&lang=js"
export * from "./EhrSimTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac74404",
  null
  
)

export default component.exports